import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "reactstrap";
import {
  setActiveTab,
  setFinalProducts,
  setMonth,
} from "../../../../redux/slices/LcaSlice";
import LcaCards2 from "./LcaCards2";
import BwvCards2 from "./BwvCards2";

const LcaAndBwvShuffle = ({ scrollPopupVisible }) => {
  const dispatch = useDispatch();
  const { finalProducts, Lca, bizzLca, bwv, finalBwv, month } = useSelector(
    (state) => state.lcAds
  );

  useEffect(() => {
    dispatch(setActiveTab(""));
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10;
  const [carouselData, setCarouselData] = useState({
    row1: [],
    row2: [],
    row3: [],
  });

  const [filteredProducts, setFilteredProducts] = useState([]);

  const shuffleArray = (array) => {
    let shuffled = array.slice();
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const fetchData = () => {
    const allAds = [...bizzLca, ...bwv];
    const row1 = [];
    const row2 = [];
    const row3 = [];
    allAds.forEach((data) => {
      if (data.bizzValue === 1) {
        row1.push(data);
      } else if (data.bizzValue === 2) {
        row2.push(data);
      } else if (data.bizzValue === 3) {
        row3.push(data);
      }
    });
    setCarouselData({
      row1: shuffleArray(row1),
      row2: shuffleArray(row2),
      row3: shuffleArray(row3),
    });
  };

  useEffect(() => {
    fetchData();
  }, [bizzLca, bwv]);

  const handleMonthChange = (newMonth) => {
    dispatch(setMonth(newMonth));
    if (!newMonth) {
      const initialProducts = Lca.filter((ad) => ad.engagedCouple === 1);
      dispatch(setFinalProducts(initialProducts));
      setFilteredProducts(initialProducts);
      return;
    }

    const filteredByEngagedCouple = Lca.filter((ad) => ad.engagedCouple === 1);
    const updatedFilteredProducts = filterProductsByEventDate(
      filteredByEngagedCouple,
      newMonth
    );

    dispatch(setFinalProducts(updatedFilteredProducts));
    setFilteredProducts(updatedFilteredProducts);
  };

  const filterProductsByEventDate = (products, month) => {
    return products.filter((product) => {
      try {
        const eventDetails = JSON.parse(product.eventDetails);
        return eventDetails.some((event) => {
          const eventDate = new Date(event.eventDate);
          return (
            !isNaN(eventDate.getTime()) &&
            `${eventDate.getFullYear()}-${String(
              eventDate.getMonth() + 1
            ).padStart(2, "0")}` === month
          );
        });
      } catch {
        return false;
      }
    });
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      paginate(currentPage - 1);
      scrollToTop();
    }
  };

  const handleNextPage = (totalPages) => {
    if (currentPage < totalPages) {
      paginate(currentPage + 1);
      scrollToTop();
    }
  };

  const scrollToTop = () => {
    const container = document.querySelector(".hompage-ads-container");
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Pagination for users and vendors
  const sortedUsers = [...finalProducts].sort(
    (a, b) => b.caIdStatus - a.caIdStatus
  );
  const sortedVendors = [...finalBwv].sort(
    (a, b) => b.caIdStatus - a.caIdStatus
  );

  // Combine all items (users and vendors) and sort by verified status
  const combinedItems = [
    ...sortedVendors.map((item) => ({ ...item, type: "vendor" })),
    ...sortedUsers.map((item) => ({ ...item, type: "user" })),
  ].sort((a, b) => {
    if (a.caIdStatus === 100 && b.caIdStatus !== 100) return -1;
    if (a.caIdStatus !== 100 && b.caIdStatus === 100) return 1;
    return 0;
  });

  const totalPages = Math.ceil(combinedItems.length / usersPerPage);
  const currentCombinedItems = combinedItems.slice(
    (currentPage - 1) * usersPerPage,
    currentPage * usersPerPage
  );

  // Debugging logs
  console.log("finalProducts length:", finalProducts.length);
  console.log("finalBwv length:", finalBwv.length);
  console.log("combinedItems length:", combinedItems.length);
  console.log("totalPages:", totalPages);
  console.log("currentPage:", currentPage);
  console.log(
    "slice indices:",
    (currentPage - 1) * usersPerPage,
    currentPage * usersPerPage
  );
  console.log("combinedItems-shuffle:", combinedItems);
  console.log("currentCombinedItems-shuffle:", currentCombinedItems);
  console.log("finalBwv-shuffle:", finalBwv);

  return (
    <>
      <div>
        {currentCombinedItems.map((item) =>
          item.type === "user" ? (
            <LcaCards2
              key={item.Id}
              allProducts={[item]}
              scrollPopupVisible={scrollPopupVisible}
              carouselData={carouselData}
            />
          ) : (
            <BwvCards2
              key={item.Id}
              allProducts={[item]}
              carouselData={carouselData}
            />
          )
        )}
      </div>
      <div className="pagination pb-3 d-flex justify-content-center">
        <Button
          className="me-2"
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <span className="align-self-center">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          className="ms-2"
          onClick={() => handleNextPage(totalPages)}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </div>
    </>
  );
};

export default LcaAndBwvShuffle;
